/**
 * 设置api请求的baseURL
 */
let configs = {
    // 请求协议
    protocol: "https",
    // 请求域名
    host: "api.hams.szlb.cc",
    // 基础路径
    basePath: "/api/tenant/wap",
};
export default {
    baseURL: configs.protocol + "://" + configs.host + configs.basePath,
    isDev: false
};



// WEBPACK FOOTER //
// ./src/configs/configs.js